import { makeStyles } from '@material-ui/styles'

export const useStyle = makeStyles(() => ({
  selectionWrapper: {
    padding: '30px',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  title: {
    fontSize: '28px',
    fontWeight: '600',
    marginBottom: '10px',
    color: '#333'
  },
  subtitle: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '30px'
  },
  card: {
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)'
    }
  },
  cardContent: {
    textAlign: 'center',
    padding: '40px 20px !important'
  },
  icon: {
    fontSize: '48px',
    color: '#fba92c',
    marginBottom: '16px'
  },
  button: {
    marginTop: '16px',
    padding: '10px 24px',
    backgroundColor: '#fba92c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e89b1f'
    }
  },
  formWrapper: {
    padding: '30px',
    maxWidth: '600px',
    margin: '0 auto'
  },
  formTitle: {
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#333'
  },
  formGroup: {
    marginBottom: '20px'
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#333'
  },
  input: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    '&:focus': {
      outline: 'none',
      borderColor: '#fba92c'
    }
  },
  submitButton: {
    padding: '12px 24px',
    backgroundColor: '#fba92c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
    '&:hover': {
      backgroundColor: '#e89b1f'
    }
  },
  backButton: {
    padding: '8px 16px',
    backgroundColor: '#f0f0f0',
    color: '#333',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
    marginBottom: '20px'
  },
  searchResults: {
    marginTop: '20px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    maxHeight: '300px',
    overflowY: 'auto'
  },
  searchResult: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  error: {
    color: '#d32f2f',
    fontSize: '14px',
    marginTop: '8px'
  },
  loading: {
    textAlign: 'center',
    padding: '20px',
    color: '#666'
  }
}))
